import Phaser from 'phaser';
import { SceneKeys } from '../game/Constants';
import { AssetRegistry } from '../systems/AssetRegistry';
import { AudioManager } from '../systems/AudioManager';
import { EventManager } from '../systems/EventManager';
import { createTextButton } from '../ui/components/UIButton';

export class EventScene extends Phaser.Scene {
  constructor() {
    super(SceneKeys.Event);
  }

  create() {
    const { width, height } = this.scale;
    const event = EventManager.instance.pendingEvent;
    this.add.rectangle(width / 2, height / 2, width, height, 0x12151c);
    if (!event) {
      this.add.text(width / 2, height / 2, 'No pending event.', { fontFamily: 'Georgia, serif', fontSize: '32px', color: '#f6e6bd' }).setOrigin(0.5);
      createTextButton(this, { label: 'Return', x: width / 2, y: height / 2 + 90, onClick: () => this.scene.start(SceneKeys.CampaignMap) });
      return;
    }

    AudioManager.instance.playUi(this, 'event_stinger_dramatic');
    const imageKey = AssetRegistry.instance.image(event.imageAsset);
    if (this.textures.exists(imageKey) && imageKey !== 'fallback.panel') this.add.image(width / 2, 280, imageKey).setDisplaySize(1040, 520);
    else this.add.rectangle(width / 2, 280, 1040, 520, 0x273142).setStrokeStyle(3, 0xb78f46);
    this.add.rectangle(width / 2, 665, 1080, 330, 0x111822, 0.94).setStrokeStyle(3, 0xb78f46);
    this.add.text(width / 2, 545, event.title, { fontFamily: 'Georgia, serif', fontSize: '38px', color: '#f6e6bd' }).setOrigin(0.5);
    this.add.text(width / 2, 600, event.description, { fontFamily: 'Arial', fontSize: '18px', color: '#f2e3c2', align: 'center', wordWrap: { width: 920 } }).setOrigin(0.5, 0);
    event.choices.forEach((choice, index) => {
      createTextButton(this, {
        label: choice.label,
        x: width / 2 - (event.choices.length - 1) * 160 + index * 320,
        y: 770,
        width: 280,
        onClick: () => {
          EventManager.instance.choose(event, choice);
          this.scene.start(SceneKeys.CampaignMap);
        },
      });
    });

    const exposed = window as unknown as { render_game_to_text?: () => string; advanceTime?: (ms: number) => void };
    exposed.render_game_to_text = () => JSON.stringify({ mode: 'event', event: event.id, choices: event.choices.map((choice) => choice.id) });
    exposed.advanceTime = () => undefined;
  }
}
